import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

import {
  getProvidersList,
  changeAppointmentData,
  getFacilityList,
  addAppointment,
  addAppointmentWaitList,
  editAppointmentWaitList,
  changeLoadingState,
  changeErrorObject,
  AppointmentEdited,
  clearInput,
  GetBillingFacility,
  appointmentSaved,
  waitListAppointmentSaved,
  clearAppointmentData,
} from "../../../StateManagement/Reducers/AppointmentsState";

import SelectedProvider from "./SelectedProvider";
import SelectedOffice from "./SelectedOffice";
import TimeDateSelector from "./TimeDateSelector";

import { BsSearch } from "react-icons/bs";
import { Div, Text, NormalImage, Button } from "../../StyledComponents";
import {
  InputInlineText,
  ReasonInput,
  DropdownDiv,
  AppointmentInput,
  DropdownText,
  AppointmentInput2,
  AppointmentInput3,
  TimeDateDiv,
  DivVariant2,
  HiddenButton,
  InitialsText,
  Text1,
  ChangeText,
} from "./Styles";

import clockIcon from "../../../Assets/images/clock-icon.png";
import calendarIcon from "../../../Assets/images/calendar-icon.png";

import dateIcon from "../../../Assets/images/calendar_icon.png";
import providerIcon from "../../../Assets/images/provider_icon.png";
import specialityIcon from "../../../Assets/images/speciality.png";
import appointmentIcon from "../../../Assets/images/appointment_icon.png";
import clockLogo from "../../../Assets/images/clock_logo.png";
import officeIcon from "../../../Assets/images/office_icon.png";
import waitListIcon from "../../../Assets/images/waitListIcon.png";

import officeLogo from "../../../Assets/images/office_logo.png";
import providerLogo from "../../../Assets/images/pro_icon1.png";
import specialityLogo from "../../../Assets/images/speciality_logo.png";
import appointmentLogo from "../../../Assets/images/appointment_logo.png";
import reasonIcon from "../../../Assets/images/reason_icon.png";
import facility_icon from "../../../Assets/images/facility_icon.png";
import tele_icon from "../../../Assets/images/telehealth_icon.png";
import priority_inner from "../../../Assets/images/priority_inner.png";
import priority_outter from "../../../Assets/images/priority_outter.png";

import { TextVariant } from "./StyledComponents";

const AddAppointment = () => {
  // ------------------------------ State and Variables Start--------------------------------------------------- //
  const dateRef = useRef(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const providerRef = useRef(null);
  const officeRef = useRef(null);
  const specialityRef = useRef(null);
  const appointmentRef = useRef(null);
  const timeRef = useRef(null);
  const timeDivRef = useRef(null);
  const timeSelectRef = useRef(null);
  const dropRef1 = useRef(null);
  const dropRef2 = useRef(null);
  const dropRef3 = useRef(null);
  const dropRef4 = useRef(null);
  const [isWaitListChecked, setIsWaitListChecked] = useState(false);
  const [dateErr, setDateErr] = useState(false);
  const [priorityErr, setPriorityErr] = useState(false);

  const [providerError, setProviderError] = useState(false);
  const [specialityError, setSpecialityError] = useState(false);
  const [appointmentError, setAppointmentError] = useState(false);
  const [officeError, setOfficeError] = useState(false);
  const [providerDrop, setProviderDrop] = useState(false);
  const [officeDrop, setOfficeDrop] = useState(false);
  const [searchProvider, setSearchProvider] = useState("");
  const [searchOffice, setSearchOffice] = useState("");
  const [searchSpeciality, setSearchSpeciality] = useState("");
  const [searchAppointment, setSearchAppointment] = useState("");
  const [imageError, setImageError] = useState([]);
  const [savebtndisabled, setsavebtndisabled] = useState(false);
  const [specialityDrop, setSpecialityDrop] = useState(false);
  const [appointmentDrop, setAppointmentDrop] = useState(false);
  const appointmentData = useSelector(
    (state) => state.Appointments.appointmentData
  );
  const [waitListExtraInputs, setWaitListExtraInputs] = useState(() => ({
    priority: "",
    date: appointmentData["aptdate"],
    fromTime: "",
    toTime: "",
  }));
  const [isDropdownOpenForPriority, setIsDropdownOpenForPriority] =
    useState(false);

  const bill_facility_id = useSelector(
    (state) => state.Appointments.BillingFacility
  );
  const providersList = useSelector(
    (state) => state.Appointments.providersList
  );
  const facilityList = useSelector((state) => state.Appointments.facilityList);
  const providerLoading = useSelector(
    (state) => state.Appointments.loadingProviders
  );
  const officeLoading = useSelector(
    (state) => state.Appointments.loadingOffice
  );

  const timeError = useSelector((state) => state.Appointments.timeError);

  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0]
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const proImageUrl = backurl + "/sites/" + DBhost + "/documentimg/";
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");
  // ------------------------------ State and Variables End--------------------------------------------------- //

  // ------------------------------ Functions Start------------------------------------------------------------- //

  const convertHMS = (value) => {
    return Math.floor(value * 60);
  };

  const filterSpecialities = (searchTerm) => {
    return specialityList.filter((speciality) =>
      speciality.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const filterappointments = (searchTerm) => {
    return appointmentList.filter((appointment) =>
      appointment.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const selectProvider = (row) => {
    dispatch(changeAppointmentData({ name: "select_provider", value: row }));
    setProviderError(false);
    setProviderDrop(false);
  };

  const selectOffice = (row) => {
    dispatch(changeAppointmentData({ name: "select_office", value: row }));
    setOfficeError(false);
    setOfficeDrop(false);
  };

  const speciality = (row) => {
    dispatch(changeAppointmentData({ name: "speciality", value: row.name }));
    setSpecialityError(false);
    setSpecialityDrop(false);
  };

  const Appointment_Type = (row) => {
    dispatch(changeAppointmentData({ name: "appttype", value: row.name }));
    setAppointmentError(false);
    setAppointmentDrop(false);
  };

  const handleClick1 = (e) => {
    if (
      providerRef.current &&
      !providerRef.current.contains(e.target) &&
      e.target.name !== "submit_button"
    ) {
      setSearchProvider("");
    }
  };

  const handleClick2 = (e) => {
    if (
      officeRef.current &&
      !officeRef.current.contains(e.target) &&
      e.target.name !== "submit_button"
    ) {
      setSearchOffice("");
    }
  };

  const handleClick3 = (e) => {
    if (
      timeDivRef.current &&
      timeSelectRef.current &&
      !timeDivRef.current.contains(e.target) &&
      !timeSelectRef.current.contains(e.target)
    ) {
      dispatch(changeAppointmentData({ name: "showSelector", value: true }));
    }
  };

  const handleClick4 = (e) => {
    if (
      dropRef1.current &&
      providerRef.current &&
      !dropRef1.current.contains(e.target) &&
      !providerRef.current.contains(e.target) &&
      e.target.id !== "provider_placer" &&
      e.target.id !== "drop_container_5"
    ) {
      setProviderDrop(false);
    }
  };

  const handleClick5 = (e) => {
    if (
      dropRef2.current &&
      officeRef.current &&
      !dropRef2.current.contains(e.target) &&
      !officeRef.current.contains(e.target) &&
      e.target.id !== "office_placer" &&
      e.target.id !== "drop_container_1"
    ) {
      setOfficeDrop(false);
    }
  };
  const handleClick6 = (e) => {
    if (
      specialityRef.current &&
      !specialityRef.current.contains(e.target) &&
      e.target.name !== "submit_button"
    ) {
      setSearchSpeciality("");
    }
  };
  const handleClick7 = (e) => {
    if (
      dropRef3.current &&
      specialityRef.current &&
      !dropRef3.current.contains(e.target) &&
      !specialityRef.current.contains(e.target) &&
      e.target.id !== "speciality_placer" &&
      e.target.id !== "drop_container_2"
    ) {
      setSpecialityDrop(false);
    }
  };
  const handleClick8 = (e) => {
    if (
      appointmentRef.current &&
      !appointmentRef.current.contains(e.target) &&
      e.target.name !== "submit_button"
    ) {
      setSearchAppointment("");
    }
  };
  const handleClick9 = (e) => {
    if (
      dropRef4.current &&
      appointmentRef.current &&
      !dropRef4.current.contains(e.target) &&
      !appointmentRef.current.contains(e.target) &&
      e.target.id !== "drop_container_4" &&
      e.target.id !== "appointment_placer"
    ) {
      setAppointmentDrop(false);
    }
  };
  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const getInitials = (x) => {
    let a = x.split(" ");
    let b = a[0].substr(0, 1).toUpperCase();
    return b;
  };
  const waitListCancelBut = () => {
    setWaitListExtraInputs({
      priority: "",
      date: "",
      fromTime: "",
      toTime: "",
    });
    setIsWaitListChecked(false);
    navigation("/appointment/add_appointment");
    dispatch(clearAppointmentData(""));
  };
  const specialityList = [
    { id: 1, value: "Plastic Surgery", name: "Plastic Surgery" },
    { id: 2, value: "Dermatology", name: "Dermatology" },
    { id: 3, value: "Sleep Medicine", name: "Sleep Medicine" },
    { id: 4, value: "Allergy & Immunology", name: "Allergy & Immunology" },
    { id: 5, value: "Concierge Medicine", name: "Concierge Medicine" },
    { id: 6, value: "Oncology", name: "Oncology" },
    { id: 7, value: "Palliative Care", name: "Palliative Care" },
    { id: 8, value: "Endocrinology", name: "Endocrinology" },
    { id: 9, value: "Sports Medicine", name: "Sports Medicine" },
    { id: 10, value: "Other", name: "Other" },
    { id: 11, value: "Hospice", name: "Hospice" },
    { id: 12, value: "Pediatrics", name: "Pediatrics" },
    { id: 13, value: "Pathology", name: "Pathology" },
    {
      id: 14,
      value: "Obstetrics and Gynecology",
      name: "Obstetrics and Gynecology",
    },
    { id: 15, value: "Hand Surgery", name: "Hand Surgery" },
    { id: 16, value: "Hematology", name: "Hematology" },
    { id: 17, value: "Emergency Medicine", name: "Emergency Medicine" },
    { id: 18, value: "Surgery", name: "Surgery" },
    { id: 19, value: "Cardiology", name: "Cardiology" },
    { id: 20, value: "Vascular Surgery", name: "Vascular Surgery" },
    { id: 21, value: "Pulmonology", name: "Pulmonology" },
    { id: 22, value: "Radiology", name: "Radiology" },
    { id: 23, value: "ECG Management", name: "ECG Management" },
    {
      id: 24,
      value: "Physical Medicine & Rehabilitation",
      name: "Physical Medicine & Rehabilitation",
    },
    { id: 25, value: "Ophthalmology", name: "Ophthalmology" },
    { id: 26, value: "Geriatric Medicine", name: "Geriatric Medicine" },
    { id: 27, value: "Neurology", name: "Neurology" },
    { id: 28, value: "Infectious Disease", name: "Infectious Disease" },
    { id: 29, value: "Nephrology", name: "Nephrology" },
    {
      id: 30,
      value: "Ambulatory Care & Surgery",
      name: "Ambulatory Care & Surgery",
    },
    { id: 31, value: "Otolaryngology (ENT)", name: "Otolaryngology (ENT)" },
    { id: 32, value: "Dental Health", name: "Dental Health" },
    { id: 33, value: "Chiropractic", name: "Chiropractic" },
    { id: 34, value: "Psychiatry", name: "Psychiatry" },
    { id: 35, value: "Urology", name: "Urology" },
    { id: 36, value: "Wound Care", name: "Wound Care" },
    { id: 37, value: "Orthopedic Surgery", name: "Orthopedic Surgery" },
    { id: 38, value: "Behaviour Health", name: "Behaviour Health" },
    { id: 39, value: "Gastroenterology", name: "Gastroenterology" },
    { id: 40, value: "Anesthesiology", name: "Anesthesiology" },
    { id: 41, value: "Family Medicine", name: "Family Medicine" },
    { id: 42, value: "Podiatry", name: "Podiatry" },
    { id: 43, value: "Austism", name: "Austism" },
    { id: 44, value: "Rheumatology", name: "Rheumatology" },
    { id: 45, value: "Acupuncture", name: "Acupuncture" },
    { id: 46, value: "Opthalmology", name: "Opthalmology" },
    {
      id: 47,
      value: "Behavioral health therapy",
      name: "Behavioral health therapy",
    },
    {
      id: 48,
      value: "Lactation consulting",
      name: "Lactation consulting",
    },
    {
      id: 49,
      value: "Massage therapy",
      name: "Massage therapy",
    },
    {
      id: 50,
      value: "Counseling",
      name: "Counseling",
    },
    {
      id: 51,
      value: "Marriage and family therapy",
      name: "Marriage and family therapy",
    },
    {
      id: 52,
      value: "Psychology",
      name: "Psychology",
    },
    {
      id: 53,
      value: "Social work",
      name: "Social work",
    },
    {
      id: 54,
      value: "Dietetics or nutrition counseling",
      name: "Dietetics or nutrition counseling",
    },
    {
      id: 55,
      value: "Applied behavior analysis",
      name: "Applied behavior analysis",
    },
    {
      id: 56,
      value: "Occupational therapy",
      name: "Occupational therapy",
    },
    {
      id: 57,
      value: "Physical therapy",
      name: "Physical therapy",
    },
    {
      id: 58,
      value: "Speech-language pathology",
      name: "Speech-language pathology",
    },
    {
      id: 59,
      value: "Substance use counseling",
      name: "Substance use counseling",
    },
  ];

  const appointmentList = [
    { id: 1, name: "Appointment" },
    { id: 2, name: "Telehealth" },
  ];

  const errorImage = (id) => {
    setImageError([id, ...imageError]);
  };
  const handlePriorityChange = (e) => {
    setPriorityErr(false);
    setWaitListExtraInputs((prev) => ({ ...prev, priority: e.target.value }));
  };

  // Handle date/time change
  const handleChange = (field, value) => {
    setDateErr(false);
    setWaitListExtraInputs((prev) => ({ ...prev, [field]: value }));
  };
  const saveWaitListAppointment = async () => {
    let err = 0;
    if (waitListExtraInputs.priority === "") {
      setPriorityErr(true);
      err = 1;
    } else {
      setPriorityErr(false);
    }
    if (
      waitListExtraInputs.fromTime === "" ||
      waitListExtraInputs.toTime === "" ||
      waitListExtraInputs.date === ""
    ) {
      setDateErr(true);
      err = 2;
    } else {
      setDateErr(false);
    }

    if (err > 0) {
      return false;
    } else {
      if (appointmentData["appttype"] === "Appointment") {
        var appttypenew = 1;
      } else {
        appttypenew = 2;
      }
      const priorityMap = {
        Urgent: 1,
        High: 2,
        Medium: 3,
        Low: 4,
      };

      // Handle both numeric and string input safely
      const priorityValue =
        typeof waitListExtraInputs.priority === "number"
          ? waitListExtraInputs.priority
          : priorityMap[waitListExtraInputs.priority] || "";
      const article = {
        patient_id: Pat_ID,
        appt_type: appttypenew,
        facility: appointmentData["office"],
        provider: appointmentData["provider"],
        appt_date: waitListExtraInputs.date,
        pref_start_time: waitListExtraInputs.fromTime,
        pref_end_time: waitListExtraInputs.toTime,
        priority: priorityValue,
        speciality: appointmentData["speciality"],
        reason: appointmentData["reason"],
        appt_profile: "",
        accepted: 0,
        id: appointmentData["id"],
        notification: 0,
      };
      try {
        if (
          appointmentData["id"] === 0 ||
          appointmentData["id"] === undefined
        ) {
          dispatch(addAppointmentWaitList(article));
        } else {
          dispatch(editAppointmentWaitList(article));
        }
      } catch (error) {
        console.error("Error in waitlist operation:", error);
      }
    }
  };
  const saveAppointment = () => {
    setsavebtndisabled(true);
    setTimeout(() => {
      setsavebtndisabled(false);
    }, 1200);

    if (bill_facility_id === undefined) {
      dispatch(
        appointmentSaved({
          color: "danger",
          message:
            "unable to book appointments as there is no billing facility provided.\nContact provider for more information",
        })
      );
      return;
    }
    let err = 0;
    if (appointmentData["provider"] === "") {
      setProviderError(true);
      err = 2;
    }
    if (appointmentData["office"] === "") {
      setOfficeError(true);
      err = 2;
    }
    if (appointmentData["speciality"] === "") {
      setSpecialityError(true);
      err = 2;
    }
    if (appointmentData["appttype"] === "") {
      setAppointmentError(true);
      err = 2;
    }
    if (appointmentData["apttime"] === "") {
      dispatch(changeErrorObject({ name: "noTime", value: true }));
      err = 2;
    }

    if (err > 0) {
      return false;
    } else {
      const timenew =
        appointmentData["aptdate"] + " " + appointmentData["apttime"];

      const timedetnew = moment(timenew, "YYYY-MM-DD hh:mm a");
      const durationnew = 15;

      if (appointmentData["appttype"] === "Appointment") {
        var appttypenew = 1,
          categoryId = 2,
          pc_title = "New Patient",
          pc_apptstatus = "not_confirmed";
      } else {
        appttypenew = 2;
        categoryId = 2;
        pc_title = "Tele Health";
        pc_apptstatus = "not_confirmed";
      }

      let alldaynew = false;
      let walkinnew = false;
      let repeats = "";
      let select1 = 0;
      let select2 = 0;
      let untildate = "";
      let fromdate = appointmentData["aptdate"];
      let todate = appointmentData["aptdate"];
      let days_wise = false;

      let tempdatenew = moment(timedetnew, moment.defaultFormat).toDate();
      let startTimenew = moment(tempdatenew).format("hh:mm a");
      let returned_endatenew = moment(tempdatenew, "YYYY-MM-DD hh:mm a").add(
        durationnew,
        "minutes"
      );
      let startdatenew = moment(tempdatenew).format("YYYY-MM-DD");
      let secondsnew = convertHMS(durationnew);
      let endTimenew = moment(returned_endatenew).format("hh:mm a");
      let endDatenew = moment(returned_endatenew).format("YYYY-MM-DD");

      const article = {
        pc_pid: Pat_ID,
        pc_catid: categoryId,
        pc_aid: appointmentData["provider"],
        pc_title,
        pc_duration: secondsnew,
        pc_hometext: "",
        pc_apptstatus,
        pc_eventDate: startdatenew,
        pc_endDate: endDatenew,
        pc_startTime: startTimenew,
        pc_endTime: endTimenew,
        pc_facility: appointmentData["office"],
        pc_informant: appointmentData["provider"],
        pc_billing_location: "",
        pc_select1: select1,
        pc_select2: select2,
        pc_untildate: untildate,
        pc_fromdate: fromdate,
        pc_todate: todate,
        days_wise: days_wise,
        allday: alldaynew,
        repeats: repeats,
        appttype: appttypenew,
        walkin: walkinnew,
        encounter: appointmentData["encounter"],
        eid: appointmentData["eid"],
        patient_reason: appointmentData["reason"],
        speciality: appointmentData["speciality"],
      };
      if (appointmentData["eid"] === 0) {
        dispatch(addAppointment(article));
      } else {
        dispatch(AppointmentEdited(article));
      }
    }
  };
  function convertTo24Hour(timeStr) {
    if (!timeStr) return "";
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");

    hours = parseInt(hours, 10);
    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${String(hours).padStart(2, "0")}:${minutes}`;
  }
  function formatTime12(time24) {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${suffix}`;
  }

  // ------------------------------ Functions End------------------------------------------------------------- //

  // ------------------------------ useEffect Start------------------------------------------------------------- //
  useEffect(() => {
    setWaitListExtraInputs((prev) => ({
      ...prev,
      date: appointmentData["aptdate"],
    }));
  }, [appointmentData["aptdate"]]);
  //provider search
  useEffect(() => {
    let isCancelled = false;

    const handlechange = async () => {
      if (appointmentData["office"] !== "") {
        dispatch(changeLoadingState({ name: "loadProvider", value: true }));
        await timeout(1000);
        if (!isCancelled) {
          dispatch(
            getProvidersList({
              name: searchProvider,
              facility_id: appointmentData["office"],
              pid: Pat_ID,
              selectSpeciality: appointmentData["speciality"],
              appttype: appointmentData["appttype"],
            })
          );
        }
      }
    };

    handlechange();
    return () => {
      isCancelled = true;
    };
  }, [
    dispatch,
    searchProvider,
    appointmentData["office"],
    Pat_ID,
    appointmentData["speciality"],
    appointmentData["appttype"],
  ]);

  //office search
  useEffect(() => {
    let isCancelled = false;

    const handlechange = async () => {
      dispatch(changeLoadingState({ name: "loadOffice", value: true }));
      await timeout(1000);
      if (!isCancelled) {
        dispatch(getFacilityList({ find: searchOffice }));
      }
    };

    handlechange();
    return () => {
      isCancelled = true;
    };
  }, [dispatch, searchOffice]);

  useEffect(() => {
    document.addEventListener("click", handleClick4);
    document.addEventListener("click", handleClick5);
    document.addEventListener("click", handleClick7);
    document.addEventListener("click", handleClick9);
    document.addEventListener("mouseup", handleClick1);
    document.addEventListener("mouseup", handleClick2);
    document.addEventListener("mouseup", handleClick3);
    document.addEventListener("mouseup", handleClick6);
    document.addEventListener("mouseup", handleClick8);

    return () => {
      document.removeEventListener("click", handleClick4);
      document.removeEventListener("click", handleClick5);
      document.removeEventListener("click", handleClick7);
      document.removeEventListener("click", handleClick9);
      document.removeEventListener("mouseup", handleClick1);
      document.removeEventListener("mouseup", handleClick2);
      document.removeEventListener("mouseup", handleClick3);
      document.removeEventListener("mouseup", handleClick6);
      document.removeEventListener("mouseup", handleClick8);
    };
  }, []);

  useEffect(() => {
    if (appointmentData["changeUrl"].length > 0) {
      navigation(`${appointmentData["changeUrl"]}`);
    }
  }, [navigation, appointmentData["changeUrl"]]);

  useEffect(() => {
    dispatch(GetBillingFacility());
  }, []);
  useEffect(() => {
    if (appointmentData["type"] === "waitlist") {
      // Extract from and to times safely
      let fromTime = "";
      let toTime = "";

      if (appointmentData["Time"]) {
        const [from, to] = appointmentData["Time"].split(" - ");
        fromTime = from ? convertTo24Hour(from.trim()) : "";
        toTime = to ? convertTo24Hour(to.trim()) : "";
      }

      // Map numeric IDs to labels
      const priorityLabelMap = {
        1: "Urgent",
        2: "High",
        3: "Medium",
        4: "Low",
      };

      // Convert numeric priority to string label
      const priorityLabel =
        priorityLabelMap[Number(appointmentData["priority"])] || "";
      // Set state
      setWaitListExtraInputs((prev) => ({
        ...prev,
        date: appointmentData["aptdate"] || "",
        fromTime: fromTime,
        toTime: toTime,
        priority:
          waitListExtraInputs.priority === ""
            ? priorityLabel
            : waitListExtraInputs.priority,
      }));
    }
  }, [appointmentData]);

  // ------------------------------ useEffect End------------------------------------------------------------- //
  return (
    <Div
      backColor="#f4f4f4"
      width="100%"
      height="100%"
      overflowY="auto"
      flexCenterHorizontal
    >
      <DivVariant2>
        <Div display="flex" justifyContent="space-between" alignItems="center">
          <Div>
            <Text1 align="left" fontWeight="500" className="createfont">
              {appointmentData["eid"] !== 0
                ? "Edit Appointment"
                : "Create new appointment"}
            </Text1>
          </Div>
          {(isWaitListChecked || appointmentData["type"] === "waitlist") && (
            <Div
              display="flex"
              justifyContent="between"
              backColor="rgba(44, 123, 229, 0.15)"
              borderRadius="60px"
              padding="6px 8px"
              alignItems="center"
            >
              <NormalImage
                loading="lazy"
                src={waitListIcon}
                height="13.33px"
                width="14.67px"
              />
              <Text
                fontSize="12px"
                fontWeight="500"
                width="auto"
                margin="0px 0px 0px 12px"
                color="rgba(44, 123, 229, 1)"
              >
                Waitlist has been enabled
              </Text>
            </Div>
          )}
        </Div>
        {(isWaitListChecked || appointmentData["type"] === "waitlist") && (
          <Text
            fontSize="12px"
            fontWeight="400"
            textAlign="left"
            margin="5px 0px 0px 0px"
          >
            You’re adding this appointment to the waitlist. Select your
            preferred time range and additional preferences below.
          </Text>
        )}
        <Div
          margin="20px 0px 0px 0px"
          flexCenterBetween
          height={appointmentData["office"] === "" ? "100px" : "auto"}
        >
          <Div flexCenterVertical>
            <NormalImage
              loading="lazy"
              src={officeIcon}
              height="13.33px"
              width="14.67px"
            />
            <Text
              fontSize="13px"
              fontWeight="400"
              width="auto"
              margin="0px 0px 0px 12px"
            >
              Office
            </Text>
            {appointmentData["office"] !== "" && (
              <HiddenButton
                mediaWidth="1300px"
                color="#407BFF"
                fontSize="12px"
                marginLeft="12px"
                background="white"
                cursor="pointer"
                onClick={() => dispatch(clearInput("office"))}
              >
                Edit
              </HiddenButton>
            )}
          </Div>
          <Div
            backColor="rgba(46, 46, 46, 0.05)"
            width="55%"
            height="100%"
            position="relative"
            id="drop_container_1"
          >
            {appointmentData["office"] !== "" ? (
              <SelectedOffice
                Type="office"
                isWaitListChecked={isWaitListChecked}
              />
            ) : (
              <>
                <AppointmentInput2
                  errorBorder={officeError}
                  name="office"
                  backgroundImage={officeLogo}
                  placeholder="Type a customer name"
                  ref={officeRef}
                  value={searchOffice}
                  onChange={(e) => {
                    setSearchOffice(e.target.value);
                  }}
                  dropOpen={officeDrop}
                  onClick={() => setOfficeDrop(true)}
                  onFocus={() => setOfficeDrop(true)}
                  id="aptLst_napt-inp_ofc"
                />
                <BsSearch id="inFocus1" />
                {officeError && (
                  <Text
                    color="#F65160"
                    margin="2px 0px 0px 0px"
                    fontSize="12px"
                    width="100%"
                    align="center"
                  >
                    Select an office
                  </Text>
                )}

                <InputInlineText
                  id="office_placer"
                  onClick={() => officeRef.current.focus()}
                >
                  Select Office
                </InputInlineText>
                {officeDrop && (
                  <DropdownDiv
                    width="100%"
                    id="inFocus2"
                    ref={dropRef2}
                    onClick={() => {
                      setOfficeDrop(false);
                    }}
                  >
                    {officeLoading ? (
                      <DropdownText
                        width="100%"
                        border="none"
                        padding="0 16px"
                        flexCenterVertical
                      >
                        Loading...
                      </DropdownText>
                    ) : (
                      <>
                        {facilityList.length !== 0 ? (
                          <>
                            {facilityList.map((row) => (
                              <DropdownText
                                width="100%"
                                border="none"
                                height="50px"
                                flexCenterVertical
                                name="office"
                                paddingLeft="16px"
                                key={row.id}
                                onClick={(e) => selectOffice(row)}
                              >
                                {row.name}
                              </DropdownText>
                            ))}
                          </>
                        ) : (
                          <DropdownText
                            width="100%"
                            border="none"
                            flexCenterVertical
                            padding="0 16px"
                          >
                            No Results Found
                          </DropdownText>
                        )}
                      </>
                    )}
                  </DropdownDiv>
                )}
              </>
            )}
          </Div>
        </Div>

        {/* speciality */}

        <Div
          margin="20px 0 0"
          flexCenterBetween
          height={appointmentData["speciality"] === "" ? "100px" : "auto"}
        >
          <Div flexCenterVertical>
            <NormalImage loading="lazy" src={specialityIcon} />
            <Text
              fontSize="13px"
              fontWeight="400"
              width="auto"
              margin="0px 0px 0px 12px"
            >
              Speciality
            </Text>
            {appointmentData["speciality"] !== "" && (
              <HiddenButton
                mediaWidth="1100px"
                color="#407BFF"
                fontSize="12px"
                marginLeft="12px"
                background="white"
                cursor="pointer"
                onClick={() => {
                  dispatch(
                    changeAppointmentData({ name: "speciality", value: "" })
                  );
                  setSpecialityDrop(true);
                  dispatch(clearInput("provider"));
                }}
              >
                Edit
              </HiddenButton>
            )}
          </Div>
          <Div
            width="55%"
            height="100%"
            position="relative"
            id="drop_container_2"
          >
            {appointmentData["speciality"] !== "" ? (
              <Div
                border="1px solid #407BFF"
                borderRadius="6px"
                width="100%"
                padding="12px 16px"
                backColor={isWaitListChecked && "rgba(46, 46, 46, 0.05)"}
              >
                {!isWaitListChecked && (
                  <ChangeText
                    mediaWidth="1100px"
                    absolute
                    onClick={() => {
                      dispatch(
                        changeAppointmentData({ name: "speciality", value: "" })
                      );
                      setSpecialityDrop(true);
                      dispatch(clearInput("provider"));
                    }}
                  >
                    Change
                  </ChangeText>
                )}
                <TextVariant width="100%" align="center">
                  {appointmentData["speciality"]}
                </TextVariant>
              </Div>
            ) : (
              <>
                <AppointmentInput2
                  errorBorder={specialityError}
                  name="speciality"
                  backgroundImage={specialityLogo}
                  placeholder="Type a speciality"
                  ref={specialityRef}
                  value={searchSpeciality}
                  onChange={(e) => {
                    setSearchSpeciality(e.target.value);
                  }}
                  dropOpen={specialityDrop}
                  onClick={() => setSpecialityDrop(true)}
                  onFocus={() => setSpecialityDrop(true)}
                  id="aptLst_napt-inp_special"
                />
                <BsSearch id="inFocus1" />
                {specialityError && (
                  <Text
                    color="#F65160"
                    margin="2px 0px 0px 0px"
                    fontSize="12px"
                    width="100%"
                    align="center"
                  >
                    Select a Speciality
                  </Text>
                )}

                <InputInlineText
                  id="speciality_placer"
                  onClick={() => specialityRef.current.focus()}
                >
                  Select Speciality
                </InputInlineText>
                {specialityDrop && (
                  <DropdownDiv
                    width="100%"
                    id="inFocus2"
                    ref={dropRef3}
                    onClick={() => setSpecialityDrop(false)}
                    style={{ overflowX: "hidden" }}
                  >
                    {filterSpecialities(searchSpeciality).length !== 0 ? (
                      <>
                        {filterSpecialities(searchSpeciality).map((row) => (
                          <DropdownText
                            width="100%"
                            border="none"
                            height="32px"
                            padding=" 0 0 0 18px"
                            flexCenterVertical
                            name="speciality"
                            key={row.id}
                            onClick={(e) => speciality(row)}
                          >
                            {row.name}
                          </DropdownText>
                        ))}
                      </>
                    ) : (
                      <DropdownText
                        width="100%"
                        border="none"
                        flexCenterVertical
                        padding="0 16px"
                      >
                        No Results Found
                      </DropdownText>
                    )}
                  </DropdownDiv>
                )}
              </>
            )}
          </Div>
        </Div>

        {/* Speciality End */}

        {/* Appointment type Start */}
        {}
        <Div
          margin="20px 0 0"
          flexCenterBetween
          height={appointmentData["appttype"] === "" ? "100px" : "auto"}
        >
          <Div flexCenterVertical>
            <NormalImage loading="lazy" src={appointmentIcon} />
            <Text
              fontSize="13px"
              fontWeight="400"
              width="auto"
              margin="0px 0px 0px 12px"
            >
              Appointment
            </Text>
            {appointmentData["appttype"] !== "" && (
              <HiddenButton
                mediaWidth="1100px"
                color="#407BFF"
                fontSize="12px"
                marginLeft="12px"
                background="white"
                cursor="pointer"
                onClick={() => {
                  dispatch(
                    changeAppointmentData({ name: "appttype", value: "" })
                  );
                  setAppointmentDrop("");
                  dispatch(clearInput("provider"));
                }}
              >
                Edit
              </HiddenButton>
            )}
          </Div>
          <Div
            width="55%"
            height="100%"
            position="relative"
            id="drop_container_4"
          >
            {appointmentData["appttype"] !== "" ? (
              <Div
                border="1px solid #407BFF"
                borderRadius="6px"
                width="100%"
                padding="12px 16px"
                backColor={isWaitListChecked && "rgba(46, 46, 46, 0.05)"}
              >
                {!isWaitListChecked && (
                  <ChangeText
                    mediaWidth="1100px"
                    absolute
                    onClick={() => {
                      dispatch(
                        changeAppointmentData({ name: "appttype", value: "" })
                      );
                      dispatch(clearInput("provider"));
                    }}
                  >
                    Change
                  </ChangeText>
                )}
                <TextVariant width="100%" align="center">
                  {appointmentData["appttype"]}
                </TextVariant>
              </Div>
            ) : (
              <>
                <AppointmentInput2
                  errorBorder={appointmentError}
                  name="appointment"
                  backgroundImage={appointmentLogo}
                  placeholder="Select Appointment type"
                  ref={appointmentRef}
                  value={searchAppointment}
                  onChange={(e) => {
                    setSearchAppointment(e.target.value);
                  }}
                  dropOpen={appointmentDrop}
                  onClick={() => setAppointmentDrop(true)}
                  onFocus={() => setAppointmentDrop(true)}
                  id="aptLst_napt-inp_appointment"
                />
                <BsSearch id="inFocus1" />
                {appointmentError && (
                  <Text
                    color="#F65160"
                    margin="2px 0px 0px 0px"
                    fontSize="12px"
                    width="100%"
                    align="center"
                  >
                    Select an Appointment type
                  </Text>
                )}

                <InputInlineText
                  id="appointment_placer"
                  onClick={() => appointmentRef.current.focus()}
                >
                  Select Appointment
                </InputInlineText>
                {appointmentDrop && (
                  <DropdownDiv
                    width="100%"
                    id="inFocus2"
                    ref={dropRef4}
                    onClick={() => setAppointmentDrop(false)}
                    style={{ overflowX: "hidden" }}
                  >
                    {filterappointments(searchAppointment).length !== 0 ? (
                      <>
                        {filterappointments(searchAppointment).map((row) => (
                          <DropdownText
                            width="100%"
                            border="none"
                            height="40px"
                            flexCenterVertical
                            name="appointment"
                            key={row.id}
                            onClick={(e) => Appointment_Type(row)}
                          >
                            <NormalImage
                              loading="lazy"
                              src={
                                row.name === "Telehealth"
                                  ? tele_icon
                                  : facility_icon
                              }
                              margin="9px 11px 9px 16px"
                              height="32px"
                              width="32px"
                              circle
                            />
                            {row.name}
                          </DropdownText>
                        ))}
                      </>
                    ) : (
                      <DropdownText
                        width="100%"
                        border="none"
                        flexCenterVertical
                        padding="0 16px"
                      >
                        No Results Found
                      </DropdownText>
                    )}
                  </DropdownDiv>
                )}
              </>
            )}
          </Div>
        </Div>

        {/*  Appointment type End */}

        {/* Provider Start */}

        <Div
          margin="20px 0 0"
          flexCenterBetween
          height={appointmentData["provider"] === "" ? "100px" : "auto"}
        >
          <Div flexCenterVertical>
            <NormalImage
              loading="lazy"
              src={providerIcon}
              width="14.67px"
              height="15.2px"
            />
            <Text
              fontSize="13px"
              fontWeight="400"
              width="auto"
              margin="0px 0px 0px 12px"
            >
              Provider
            </Text>
            {appointmentData["provider"] !== "" && (
              <HiddenButton
                mediaWidth="1100px"
                color="#407BFF"
                fontSize="12px"
                marginLeft="12px"
                background="white"
                cursor="pointer"
                onClick={() => {
                  dispatch(clearInput("provider"));
                }}
              >
                Edit
              </HiddenButton>
            )}
          </Div>
          <Div
            width="55%"
            height="100%"
            position="relative"
            id="drop_container_5"
          >
            {appointmentData["provider"] !== "" ? (
              <SelectedProvider isWaitListChecked={isWaitListChecked} />
            ) : (
              <>
                <AppointmentInput
                  errorBorder={providerError}
                  name="provider"
                  placeholder="Search Provider"
                  value={searchProvider}
                  onChange={(e) => {
                    setSearchProvider(e.target.value);
                  }}
                  backgroundImage={providerLogo}
                  ref={providerRef}
                  dropOpen={providerDrop}
                  onClick={() => setProviderDrop(true)}
                  onFocus={() => setProviderDrop(true)}
                  id="aptLst_napt-inp_prdr"
                />
                <BsSearch id="inFocus1" />
                {providerError && (
                  <Text
                    color="#F65160"
                    margin="2px 0px 0px 0px"
                    fontSize="12px"
                    width="100%"
                    align="center"
                  >
                    Select a provider
                  </Text>
                )}
                <InputInlineText
                  onClick={() => providerRef.current.focus()}
                  id="provider_placer"
                >
                  Select Provider
                </InputInlineText>
                {providerDrop && (
                  <DropdownDiv
                    width="100%"
                    padding="8px 0px"
                    id="inFocus2"
                    ref={dropRef1}
                  >
                    {providerLoading ? (
                      <DropdownText
                        width="100%"
                        border="none"
                        padding="0 16px"
                        flexCenterVertical
                      >
                        Loading...
                      </DropdownText>
                    ) : (
                      <>
                        {providersList.length !== 0 &&
                        appointmentData["speciality"] !== "" ? (
                          <>
                            {providersList.map((row) => (
                              <DropdownText
                                width="100%"
                                border="none"
                                flexCenterVertical
                                height="36px"
                                name="provider"
                                key={row.id}
                                onClick={(e) => selectProvider(row)}
                              >
                                <Div
                                  width="max-content"
                                  hoverBackColor="#ececec"
                                >
                                  {row.img_url &&
                                  row.img_url.length > 0 &&
                                  !imageError.includes(row.id) ? (
                                    <NormalImage
                                      className="profile_img_respon"
                                      loading="lazy"
                                      height="28px"
                                      width="28px"
                                      borderRadius="50%"
                                      margin="2px 10px 2px 10px"
                                      src={proImageUrl + row.img_url}
                                      onError={() => errorImage(row.id)}
                                    />
                                  ) : (
                                    <InitialsText width="28px">
                                      {getInitials(row.name)}
                                    </InitialsText>
                                  )}
                                </Div>
                                <Div
                                  width="92%"
                                  title={row.name}
                                  whiteSpace="nowrap"
                                  textOverflow="ellipsis"
                                  overflow="hidden"
                                  margin="4px"
                                  backColor="none"
                                >
                                  {" "}
                                  {row.name}
                                </Div>
                              </DropdownText>
                            ))}
                          </>
                        ) : (
                          <DropdownText
                            width="100%"
                            border="none"
                            flexCenterVertical
                            padding="0 16px"
                          >
                            {appointmentData["office"] !== ""
                              ? "No Results Found"
                              : "Select an office, speciality and appointment type"}
                          </DropdownText>
                        )}
                      </>
                    )}
                  </DropdownDiv>
                )}
              </>
            )}
          </Div>
        </Div>

        {/* Provider End */}
        <Div
          margin="20px 0px 0px 0px"
          display="flex"
          alignItems="start"
          height={
            appointmentData["apttime"] === "" && !isWaitListChecked
              ? "100px"
              : "auto"
          }
          ref={timeDivRef}
          position="relative"
        >
          {appointmentData["showSelector"] ||
          isWaitListChecked ||
          appointmentData["type"] === "waitlist" ? (
            <>
              {/* Left Section - Time and Date Label */}
              <Div flexCenterVertical width="45%">
                <NormalImage
                  loading="lazy"
                  src={dateIcon}
                  height="16px"
                  width="16px"
                />
                <Text
                  fontSize="13px"
                  fontWeight="400"
                  width="auto"
                  margin="0px 0px 0px 12px"
                >
                  Time and date
                </Text>

                {appointmentData["timeSelected"] && (
                  <HiddenButton
                    cursor="pointer"
                    mediaWidth="1100px"
                    onClick={() => dispatch(clearInput("time"))}
                  >
                    Edit
                  </HiddenButton>
                )}
              </Div>

              {/* Right Section - Time Input / Selected Time */}
              {!isWaitListChecked &&
                appointmentData["type"] !== "waitlist" &&
                (!appointmentData["timeSelected"] ? (
                  <Div width="55%" height="100%" position="relative">
                    <InputInlineText
                      onClick={() => timeRef.current.focus()}
                      id="aptLst_napt-p_dt"
                    >
                      Select Time &#38; Date
                    </InputInlineText>

                    <AppointmentInput3
                      errorBorder={
                        timeError["noTime"] || timeError["noProvider"]
                      }
                      backgroundImage={clockLogo}
                      onClick={() =>
                        dispatch(
                          changeAppointmentData({
                            name: "showSelector",
                            value: false,
                          })
                        )
                      }
                      onFocus={() =>
                        dispatch(
                          changeAppointmentData({
                            name: "showSelector",
                            value: false,
                          })
                        )
                      }
                      name="time"
                      ref={timeRef}
                    />

                    {(timeError["noTime"] || timeError["noProvider"]) && (
                      <Text1
                        color="#F65160"
                        margin="2px 0px 0px 0px"
                        className={
                          timeError["noTime"]
                            ? "availabilityerr"
                            : "availabilityerr1"
                        }
                        width="100%"
                        align="center"
                      >
                        {timeError["noTime"]
                          ? "Select a time & date"
                          : "Select a provider to check availability"}
                      </Text1>
                    )}
                  </Div>
                ) : (
                  <SelectedOffice
                    Type="time"
                    isWaitListChecked={isWaitListChecked}
                  />
                ))}
            </>
          ) : (
            !isWaitListChecked &&
            appointmentData["type"] !== "waitlist" && (
              <TimeDateDiv ref={timeSelectRef}>
                <TimeDateSelector
                  isWaitListChecked={isWaitListChecked}
                  setIsWaitListChecked={setIsWaitListChecked}
                />
              </TimeDateDiv>
            )
          )}
          {/* Date and Time Inputs */}
          {(isWaitListChecked || appointmentData["type"] === "waitlist") && (
            <>
              {" "}
              <Div display="flex" gap="5px" width="55%">
                {/* Date */}
                {/* 📅 Date Selector */}
                <Div
                  border="1px dashed rgba(46, 46, 46, 0.15)"
                  display="flex"
                  alignItems="center"
                  gap="7px"
                  padding="16px 5px"
                  width="37%"
                  justifyContent="space-between"
                  onClick={() => dateRef.current?.showPicker()} // open the native date picker
                  style={{ cursor: "pointer" }}
                >
                  <Text fontSize="13px" fontWeight="400" width="auto">
                    {waitListExtraInputs.date
                      ? new Date(
                          new Date(waitListExtraInputs.date).getTime() +
                            new Date().getTimezoneOffset() * 60000
                        ).toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "2-digit",
                        })
                      : "MM/DD/YY"}
                  </Text>
                  <NormalImage
                    loading="lazy"
                    src={calendarIcon}
                    width="14.67px"
                    height="15.2px"
                  />
                  {/* hidden input */}
                  <input
                    type="date"
                    ref={dateRef}
                    value={
                      waitListExtraInputs.date ||
                      appointmentData["aptdate"] ||
                      new Date().toLocaleDateString("en-CA") // gives YYYY-MM-DD in local timezone
                    }
                    onChange={(e) => handleChange("date", e.target.value)}
                    style={{
                      opacity: 0,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  />
                </Div>

                {/* From Time */}
                <Div
                  border="1px dashed rgba(46, 46, 46, 0.15)"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap="3px"
                  padding="16px 4px"
                  width="42%"
                  onClick={() => fromRef.current?.showPicker()}
                  style={{ cursor: "pointer" }}
                >
                  <Text fontSize="13px" fontWeight="400" width="auto">
                    {waitListExtraInputs.fromTime
                      ? formatTime12(waitListExtraInputs.fromTime)
                      : "From"}
                  </Text>
                  <NormalImage
                    loading="lazy"
                    src={clockIcon}
                    width="14.67px"
                    height="15.2px"
                  />
                  <input
                    type="time"
                    ref={fromRef}
                    value={waitListExtraInputs.fromTime}
                    onChange={(e) => handleChange("fromTime", e.target.value)}
                    style={{
                      opacity: 0,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  />
                </Div>

                {/* To Time */}
                <Div
                  border="1px dashed rgba(46, 46, 46, 0.15)"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap="3px"
                  padding="16px 4px"
                  width="42%"
                  onClick={() => toRef.current?.showPicker()}
                  style={{ cursor: "pointer" }}
                >
                  <Text fontSize="13px" fontWeight="400" width="auto">
                    {waitListExtraInputs.toTime
                      ? formatTime12(waitListExtraInputs.toTime)
                      : "To"}
                  </Text>
                  <NormalImage
                    loading="lazy"
                    src={clockIcon}
                    width="14.67px"
                    height="15.2px"
                  />
                  <input
                    type="time"
                    ref={toRef}
                    value={waitListExtraInputs.toTime}
                    onChange={(e) => handleChange("toTime", e.target.value)}
                    style={{
                      opacity: 0,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  />
                </Div>
              </Div>
            </>
          )}
          {/* {isWaitListChecked &&
            dateErr(
              <Text1
                color="#F65160"
                margin="2px 0px 0px 0px"
                // className={
                //   timeError["noTime"]
                //     ? "availabilityerr"
                //     : "availabilityerr1"
                // }
                width="100%"
                align="center"
              >
                Select a time & date
              </Text1>
            )} */}
        </Div>
        {(isWaitListChecked || appointmentData["type"] === "waitlist") &&
          dateErr && (
            <Text1
              color="#F65160"
              margin="2px 0px 0px 30px"
              className="availabilityerr1"
              width="100%"
              align="center"
            >
              Select a time & date
            </Text1>
          )}
        {/* Priority Dropdown */}
        {(isWaitListChecked || appointmentData["type"] === "waitlist") && (
          <Div margin="20px 0px 0px 0px" height="45px" flexCenterBetween>
            <Div flexCenterVertical>
              <NormalImage
                loading="lazy"
                src={priority_outter}
                height="16px"
                width="16px"
              />
              <Text
                fontSize="13px"
                fontWeight="400"
                width="auto"
                margin="0px 0px 0px 12px"
              >
                Priority
              </Text>
            </Div>

            <Div
              border="1px dashed rgba(46, 46, 46, 0.15)"
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap="10px"
              width="55%"
              padding="10px"
              position="relative"
              style={{ cursor: "pointer" }}
              onClick={() =>
                setIsDropdownOpenForPriority(!isDropdownOpenForPriority)
              }
            >
              <Div className="">
                <NormalImage
                  loading="lazy"
                  src={priority_inner}
                  height="16px"
                  width="16px"
                />
              </Div>
              {/* Custom Dropdown Trigger */}
              <Div
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                // width="100%"
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: waitListExtraInputs.priority
                    ? "#2e2e2e"
                    : "rgba(46,46,46,0.6)",
                }}
              >
                {waitListExtraInputs.priority || "Select Priority"}
                <i
                  className={`bi bi-chevron-${
                    isDropdownOpenForPriority ? "up" : "down"
                  }`}
                  style={{ fontSize: "12px", marginLeft: "8px" }}
                ></i>
              </Div>

              {/* Dropdown Menu */}
              {isDropdownOpenForPriority && (
                <Div
                  position="absolute"
                  top="45px"
                  left="0"
                  width="100%"
                  background="#fff"
                  border="1px solid rgba(46,46,46,0.15)"
                  borderRadius="8px"
                  zIndex="10"
                  boxShadow="0px 4px 8px rgba(0,0,0,0.1)"
                >
                  {["Urgent", "High", "Medium", "Low"].map((priority) => (
                    <Div
                      key={priority}
                      padding="10px 16px"
                      onClick={() => {
                        handlePriorityChange({ target: { value: priority } });
                        setIsDropdownOpenForPriority(false);
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#007bff")
                      } // blue
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                      style={{
                        fontSize: "14px",
                        color: "#2e2e2e",
                        cursor: "pointer",
                        transition: "background 0.2s ease",
                      }}
                    >
                      {priority}
                    </Div>
                  ))}
                </Div>
              )}
            </Div>
          </Div>
        )}
        {/* {(isWaitListChecked || appointmentData["type"] === "waitlist") && (
          <Div margin="20px 0px 0px 0px" height="45px" flexCenterBetween>
            <Div flexCenterVertical>
              <NormalImage
                loading="lazy"
                src={priority_outter}
                height="16px"
                width="16px"
              />
              <Text
                fontSize="13px"
                fontWeight="400"
                width="auto"
                margin="0px 0px 0px 12px"
              >
                Priority
              </Text>
            </Div>

            <Div
              border="1px dashed rgba(46, 46, 46, 0.15)"
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap="10px"
              width="280px"
              padding="10px"
              position="relative"
            >
              <NormalImage
                loading="lazy"
                src={priority_inner}
                height="16px"
                width="16px"
              />

              <select
                value={waitListExtraInputs.priority || appointmentData.priority}
                onChange={handlePriorityChange}
                onFocus={() => setIsDropdownOpenForPriority(true)} // dropdown opened
                onBlur={() => setIsDropdownOpenForPriority(false)} // dropdown closed
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  fontSize: "14px",
                  fontWeight: "400",
                  width: isDropdownOpenForPriority ? "500px" : "", // dynamic width
                  appearance: "none", // hides default arrow (Chrome, Safari)
                  WebkitAppearance: "none", // Safari
                  MozAppearance: "none", // Firefox
                  color: waitListExtraInputs.priority
                    ? "#2e2e2e"
                    : "rgba(46,46,46,0.6)",
                  cursor: "pointer",
                  transition: "width 0.2s ease", // smooth width change
                }}
              >
                <option value="" disabled>
                  Select Priority
                </option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </Div>
          </Div>
        )} */}

        {(isWaitListChecked || appointmentData["type"] === "waitlist") &&
          priorityErr && (
            <Text1
              color="#F65160"
              margin="2px 0px 0px 18px"
              className="availabilityerr1"
              width="100%"
              align="center"
            >
              Select Priority
            </Text1>
          )}

        <Div margin="20px 0px 0px 0px" height="67px" flexCenterBetween>
          <Div flexCenterVertical>
            <NormalImage
              loading="lazy"
              src={reasonIcon}
              height="16px"
              width="16px"
            />
            <Text
              fontSize="13px"
              fontWeight="400"
              width="auto"
              margin="0px 0px 0px 12px"
            >
              Reason for Visit
            </Text>
          </Div>
          <ReasonInput
            placeholder="Enter reason"
            value={appointmentData["reason"]}
            onChange={(e) =>
              dispatch(
                changeAppointmentData({ name: "reason", value: e.target.value })
              )
            }
            id="aptLst_napt-tare_rson"
          />
        </Div>
        {!isWaitListChecked && appointmentData["type"] !== "waitlist" ? (
          <Div width="100%" display="flex" justifyContent="end">
            <Button
              marginTop="37px"
              marginBottom="16px"
              height="40px"
              background="#2C7BE5"
              hoverBackColor="#005FB2"
              color=" #FFF"
              borderRadius="4px"
              width="55%"
              name="submit_button"
              className="save_active"
              disabled={savebtndisabled}
              onClick={saveAppointment}
              id="aptLst_napt-btn_smit"
            >
              Submit
            </Button>
          </Div>
        ) : (
          <Div display="flex" justifyContent="space-between">
            <Button
              marginTop="37px"
              marginBottom="16px"
              height="40px"
              background="rgba(255, 255, 255, 1)"
              color=" rgba(44, 123, 229, 1)"
              borderRadius="4px"
              width="30%"
              border="1px solid rgba(44, 123, 229, 1)"
              onClick={() => waitListCancelBut()}
            >
              Cancel
            </Button>{" "}
            <Button
              marginTop="37px"
              marginBottom="16px"
              height="40px"
              background="#2C7BE5"
              hoverBackColor="#005FB2"
              color=" #FFF"
              borderRadius="4px"
              width="55%"
              name="submit_button"
              className="save_active"
              disabled={savebtndisabled}
              onClick={saveWaitListAppointment}
              id="aptLst_napt-btn_smit"
            >
              Add to Waitlist
            </Button>
          </Div>
        )}
      </DivVariant2>
    </Div>
  );
};
// commit
export default AddAppointment;
